<template>
  <div class="app-single-top-up-paypal-wrapper">
    <slot name="txtBefore"></slot>
    <SingleTopUpAmountBtnSelector
      :amounts="singleTopUpStatus_.amounts.amount"
      :default-amount="singleTopUpStatus_.amounts.default"
      :payment="singleTopUpStatus_.payment"
      @showmodal="showModal"
    >
      <template v-for="slot in possibleChildSlotsFor('Amount')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </SingleTopUpAmountBtnSelector>
    <slot name="txtAfter"></slot>
    <ProcessConfirmModal :visible="show_" :showPrev="false" :showNext="false" @close="cancel()">
      <template slot="header">
        <slot name="header">
          <slot name="txtModalTitlePaypal"></slot>
        </slot>
      </template>
      <template>
        <div class="paypal-modal-wrapper">
          <slot name="txtBeforePaypal"></slot>
          <app-oppwa available-credit-cards="PAYPAL" :token="token_"></app-oppwa>
        </div>
      </template>
    </ProcessConfirmModal>
    <SingleTopUpPaypalConfirm> </SingleTopUpPaypalConfirm>
  </div>
</template>
<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import SingleTopUpAmountBtnSelector from './AmountBtnSelector.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ProcessConfirmModal from '@/components/generic/CustomModal.vue'
import SingleTopUpPaypalConfirm from '@/components/process/generic/TopUp/SingleTopUp/PaypalConfirm.vue'

export default {
  name: 'SingleTopUpPaypalWrapper',
  components: {
    ProcessConfirmModal,
    SingleTopUpAmountBtnSelector,
    SingleTopUpPaypalConfirm
  },
  props: {
    url: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {
      modalShow: false,
      loading: false,
      selectedAmount: {},
      singleTopUpStatus: {
        amounts: {
          amount: [],
          default: null
        }
      }
    }
  },
  methods: {
    ...mapMutations('topUp/paypal', ['changeAmount']),
    ...mapActions('topUp/single', ['performSingleTopUp']),
    ...mapActions('topUp/paypal', ['prepareSingleTopUpWithPayPal']),
    cancel() {
      this.modalShow = false
    },
    showModal: function(selected) {
      this.selectedAmount = selected
      this.prepareSingleTopUpWithPayPal({ amount: selected.value }).then((this.modalShow = true))
    }
  },
  computed: {
    ...mapGetters('topUp/paypal', ['token']),
    token_() {
      return this.token || null
    },
    show_: {
      set: function(value) {
        this.modalShow = value
      },
      get: function() {
        return this.token_ !== null && this.modalShow
      }
    },
    slotData() {
      return {
        selectedAmount: this.selectedAmount,
        payment: this.singleTopUpStatus_.payment
      }
    },
    singleTopUpStatus_: function() {
      return this.singleTopUpStatus
    }
  },
  mixins: [transaction('initializePayPalPayment'), slotProxy()],
  apollo: {
    singleTopUpStatus: function() {
      return wrapQuery(
        gql`
          query singleTopUp {
            singleTopUpStatus(paypal: true) {
              amounts {
                amount
                default
              }
            }
          }
        `,
        this,
        'singleTopUpStatus',
        {},
        null,
        {
          fetchPolicy: 'cache-first'
        }
      )
    }
  }
}
</script>
